"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _quarentenaApiCall = _interopRequireDefault(require("./quarentenaApiCall"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var isCanceled = true;
var redirect = function redirect(listId) {
  var base = 'https://verifique-sua-conta.olx.com.br/';
  window.location.href = "".concat(base, "?action_type=CHAT_VI&list_id=").concat(listId);
};
var redirectIfNotCanceled = function redirectIfNotCanceled(listId) {
  if (!isCanceled) {
    redirect(listId);
  }
};
var ensure = function ensure(listId) {
  isCanceled = false;
  return (0, _quarentenaApiCall["default"])().then(function (data) {
    if (data && data.label !== 'green') {
      redirectIfNotCanceled(listId);
    }
  })["catch"](function (error) {
    console.error('API error:', error);
    isCanceled = true;
  });
};
var cancel = function cancel() {
  isCanceled = true;
};
var modules = {
  ensure: ensure,
  cancel: cancel
};
var _default = exports["default"] = modules;